import React from 'react';

import { DispatchedReportItem } from '@futrli-sdk/report_scheduling';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';
import { ScheduleDerivedStatus } from '@futrli/views/processors/reportScheduling/reportSchedulingList';

import { useScheduleActionItems } from '../hooks/use-schedule-action-items';

interface ScheduleActionsPopoverProps {
  status: ScheduleDerivedStatus;
  awaitingReviewItem?: DispatchedReportItem;
  reportId?: string | null;
  reportName?: string;
  scheduleId?: string;
  onDelete: () => void;
}

export const ScheduleActionsPopover = ({ status, awaitingReviewItem, reportId, reportName, scheduleId, onDelete }: ScheduleActionsPopoverProps) => {
  const items = useScheduleActionItems({ status, awaitingReviewItem, reportId, reportName, scheduleId, onDelete });

  return <ListingPageRowActions items={items} />;
};
